
import NavLinks from './navlinks'

export default NavLinks;